'use client'
import { ChangeEvent, useEffect, useState, InputHTMLAttributes  } from "react"
import { BtnLoader } from '../../../icons';
import { Invalid, Valid } from "../../../icons";

interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
    customClassName?: string;
    onChange?: (value: string) => void;
    validate?: (value: string) => boolean | undefined;
    value?: string;
    showError?: boolean;
    errorMessage?: string;
    rightIcon?: string | null;
    isLoading?: boolean;
}

const Input: React.FC<InputProps> = ({
    customClassName = "",
    onChange,
    validate,
    value,
    showError,
    errorMessage,
    rightIcon = null,
    isLoading = false,
    ...rest
}) => {

    const [inputVal, setInputVal] = useState("")

    const _onChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { value: currentVal } = e.target
        if (!validate || validate?.(currentVal) || currentVal === "") {
            setInputVal(currentVal)
            onChange?.(currentVal)
        }
    }

    useEffect(() => {
        setInputVal(value ?? "")
    }, [value])

    return (
        <div className="relative flex flex-col">
            {(rightIcon && !isLoading) && (
                <div className="absolute right-3 top-3 w-6 h-6">
                    {(rightIcon==="valid" )? <Valid/> : <Invalid/>}
                </div>    
            )}
            <input
                className={`py-3 text-black px-2 outline-none rounded-xl-10 w-full ${customClassName}`}
                value={inputVal}
                onChange={_onChange}
                {...rest}
            />
            {isLoading && (
                <div className="absolute right-3 top-3">
                    <BtnLoader/>
                </div>
            )}
            {showError && errorMessage ? <div className="text-error text-xs mt-1">{errorMessage}</div> : null}
        </div>
    )
}

export default Input